import {
    LazyLoadImage,
    LazyLoadImageProps
} from 'react-lazy-load-image-component'
import 'styles/lazyload.css'
import { useState, useEffect } from 'react'
import { buildColoursUrl } from 'utils'

export const LazyImage = (
    props: LazyLoadImageProps & { fallbackSrc?: string }
) => {
    const { src = '', fallbackSrc = '', onError = () => null } = props
    const [imgSrc, setImgSrc] = useState<string | undefined>(src)

    useEffect(() => {
        setImgSrc(src)
    }, [src])

    return (
        <LazyLoadImage
            effect="opacity"
            {...props}
            onError={(e) => {
                if (onError) onError(e)
                if (fallbackSrc) setImgSrc(fallbackSrc)
            }}
            src={imgSrc}
        />
    )
}

export const LazyRunnerColour = (props: LazyLoadImageProps) => {
    const { src = '' } = props
    const [imgSrc, setImgSrc] = useState<string | undefined>(
        buildColoursUrl(src)
    )

    const onError = () => setImgSrc(buildColoursUrl())

    useEffect(() => {
        setImgSrc(buildColoursUrl(src))
    }, [src])

    return (
        <LazyLoadImage
            effect="opacity"
            {...props}
            src={imgSrc}
            onError={onError}
        />
    )
}
